<div fxLayout="row" class="page-footer">
    <div fxFlex fxFlexAlign="end" >
        <mat-label escCustomId="policy" >
                <p>{{webtoolVersion}} <a href="privacy-policy">Privacy Policy</a> | © Electronic Science. All Rights Reserved</p>
        </mat-label>
    </div>
</div>